import StoreLocationContainer from './containers/StoreLocationContainer';

export default StoreLocationContainer;
